import SessionItemView2 from './SessionItemView2';

export default SessionItemView2;
